export interface VersionEntry {
  version: string;
  date: string;
  title: string;
  changes: string[];
}

export const VERSION_LOG: VersionEntry[] = [
  {
    version: 'V1.3.0',
    date: '2026-08-07',
    title: '本地模式与 WebGPU 加速',
    changes: [
      '新增本地模式：默认不上传源文件，OCR 与拆分全部在浏览器内完成，结果直接下载',
      '接入 WebGPU 加速（jsep WASM 经 R2 按需加载），无 GPU 时自动回退 WASM',
      '启用 onnxruntime 多线程（COOP/COEP 跨源隔离），CPU 识别速度提升约 2 倍',
      '增加版本日志弹窗',
    ],
  },
  {
    version: 'V1.2.0',
    date: '2026-08-07',
    title: '按 PO Number 分组',
    changes: [
      '单品多件 / 多品混合订单改为按 PO Number 合并为一个 PDF（文件名以 PO 命名）',
      '单品单件订单汇总为 <源文件名>_single.pdf',
      '页面缺少 PO 时退回按 Tracking Number 分组',
    ],
  },
  {
    version: 'V1.1.0',
    date: '2026-08-07',
    title: 'OCR 引擎升级',
    changes: [
      'OCR 切换为 PP-OCRv6（oocr.app 同款引擎，ppu-paddle-ocr + onnxruntime-web）',
      '模型与 WASM 自托管，识别过程不依赖第三方 CDN',
    ],
  },
  {
    version: 'V1.0.0',
    date: '2026-08-06',
    title: '初始版本',
    changes: [
      '浏览器端 PDF 拆分工具：上传 ASN Shipping Label PDF，自动识别 Tracking Number',
      '支持单品单件汇总、多包裹订单拆分与结果批量下载',
      '接入 Cloudflare Workers + D1 + R2 与 GitHub 自动构建部署',
    ],
  },
];
